import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileText: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-text, document"><path d="M12.75 2.75H4.75V21.25H19.25V9.25L12.75 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 13.25H12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 17.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 3.25317V9.25008H18.7461" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFileText;
